import { ChangeDetectionStrategy, Component, Input, OnInit, input, computed } from '@angular/core';
import { FileType } from '@bazis/form/models/form-element.types';
import { EntData } from '@bazis/shared/models/srv.types';
import { LinkModule } from '@bazis/shared/components/web/link/link.module';
import { BadgeModule } from '@bazis/shared/components/web/badge/badge.module';
import { IconModule } from '@bazis/shared/components/web/icon/icon.module';
import { TooltipModule } from '@bazis/shared/components/web/tooltip/tooltip.module';
import { FileSizePipe } from '@bazis/shared/pipes/file-size.pipe';
import { TranslocoModule } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';
import { ColorDirective } from '@bazis/shared/directives/color.directive';

@Component({
    selector: 'bazis-file-inline',
    templateUrl: './file-inline.component.html',
    imports: [
        LinkModule,
        BadgeModule,
        IconModule,
        TooltipModule,
        FileSizePipe,
        TranslocoModule,
        CommonModule,
        ColorDirective,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileInlineComponent implements OnInit {
    readonly file = input<EntData>(null);

    readonly fileNameKey = input<string>('');

    readonly fileNameParams = input<any>(null);

    readonly hasLink = input<boolean>(true);

    readonly showFileSize = input<boolean>(true);

    // знак вопроса может быть рядом с файлом
    readonly tooltipKey = input<string>();

    // параметры для tooltip
    readonly tooltipParams = input<any>(null);

    readonly fileInfo = input<{
        id: string;
        url: string;
        name: string;
        extension: string;
        size: number;
    }>(null);

    srcFile = computed(() => {
        return this.file()
            ? this.file().$snapshot.file_upload_url || this.file().$snapshot.file
            : this.fileInfo()?.url;
    });

    nameFile = computed(() => {
        return this.file() ? this.file().$snapshot.name : this.fileInfo()?.name;
    });

    sizeFile = computed(() => {
        return this.file() ? this.file().$snapshot.size : this.fileInfo()?.size;
    });

    extension = computed(() => {
        const extensionArr = this.srcFile().split('.');
        const extension = extensionArr[extensionArr.length - 1];
        return extension.split('?')[0];
    });

    ngOnInit(): void {}
}
